import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import DirectInput from '../../../../components/directInput/DirectInput';
import emailValid from '../../../../utils/emailValid';
import phoneValid from '../../../../utils/phoneValid';
import errorHandle from '../../../../utils/errorHandle';
import { orgTripRegOTP, orgTripRegOTPResend } from '../../../../api/orgTripAPI';

export default function RegOtp({ formData, setFormData, setLoading, otpStatus, setOTPStatus }) {
    const [resendTimer, setResendTimer] = useState(0); // countdown in seconds
    const [resendIntervalId, setResendIntervalId] = useState(null); // to clear timer
    const [otpExpired, setOtpExpired] = useState(false);
    const [otpExpiryTimeoutId, setOtpExpiryTimeoutId] = useState(null);
    const [otpError, setOtpError] = useState('');
    useEffect(() => {
        return () => {
            if (resendIntervalId) clearInterval(resendIntervalId);
            if (otpExpiryTimeoutId) clearTimeout(otpExpiryTimeoutId);
        };
    }, [resendIntervalId, otpExpiryTimeoutId]);

    function startResendTimer(duration = 120) {
        // Clear previous timer if exists
        if (resendIntervalId) clearInterval(resendIntervalId);

        setResendTimer(duration);

        const intervalId = setInterval(() => {
            setResendTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalId);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        setResendIntervalId(intervalId);
    }
    async function genOTP(method) {
        //generate OTP for the email and phone nummber
        //check the phone number and email before submiting the data
        if (!phoneValid(formData.phoneNumber)) {
            toast.error('Enter a valid phone number');
            return;
        }
        if (!emailValid(formData.emailId)) {
            toast.error('Enter a valid phone number');
            return;
        }
        try {
            setLoading(true);
            await orgTripRegOTP(
                {
                    emailId: formData.emailId,
                    phoneNumber: formData.phoneNumber,
                    countryCode: formData.countryCode,
                    type: formData.type
                },
                method
            );
            setLoading(false);
            setOTPStatus(true);
            setOtpError('');
            setOtpExpired(false);
            startResendTimer(120);
            if (otpExpiryTimeoutId) {
                clearTimeout(otpExpiryTimeoutId);
            }
            const timeoutId = setTimeout(
                () => {
                    setOtpExpired(true);
                    setOtpError('OTP has expired. Generate new OTP..');
                },
                10 * 60 * 1000
            ); // 10 minutes

            setOtpExpiryTimeoutId(timeoutId);
            toast.success('OTP has been send to ' + formData.phoneNumber + ' and ' + formData.emailId);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    return (
        <div>
            <h2 className='orgRegisterH2'>OTP</h2>
            <div className='orgRegisterSecDiv'>
                {otpError !== '' && <span className='orgLoginError'>{otpError}</span>}
                <br />
                {!otpStatus ? (
                    <button
                        type='button'
                        className={
                            formData.phoneNumber && formData.emailId && !otpStatus ? 'orgRegisterAddBtn blueBtn' : ''
                        }
                        disabled={formData.phoneNumber && formData.emailId && !otpStatus ? false : true}
                        onClick={() => genOTP('register')}
                    >
                        Generate OTP
                    </button>
                ) : !otpExpired ? (
                    resendTimer > 0 ? (
                        <p className='resend-timer'>
                            Resend OTP in {Math.round(resendTimer / 60)}:{String(resendTimer % 60).padStart(2, '0')}
                        </p>
                    ) : (
                        <button className='resend-btn' onClick={() => genOTP('resend')}>
                            Resend OTP
                        </button>
                    )
                ) : (
                    <button
                        type='button'
                        className={'orgRegisterAddBtn blueBtn'}
                        // disabled={formData.phoneNumber && formData.emailId && !otpStatus ? false : true}
                        onClick={() => genOTP('register')}
                    >
                        Re-Generate OTP
                    </button>
                )}
                {formData.phoneNumber && formData.emailId && (
                    <p className='regOTPP'>
                        OTP will be sent to {formData.phoneNumber} and {formData.emailId}
                    </p>
                )}

                {otpStatus && (
                    <>
                        <DirectInput
                            label='Phone OTP'
                            name={'phoneOTP'}
                            value={formData.phoneOTP}
                            type='number'
                            placeholder=''
                            setFormData={setFormData}
                            min={6}
                            limit={6}
                            nest=''
                        />
                        <DirectInput
                            label='Email OTP'
                            name={'emailOTP'}
                            value={formData.emailOTP}
                            type='number'
                            placeholder=''
                            setFormData={setFormData}
                            min={6}
                            limit={6}
                            nest=''
                        />
                    </>
                )}
            </div>
        </div>
    );
}
